(function () {
  'use strict';

  function getApiUrl() {
    var el = document.getElementById('ts-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent).apiUrl || null; } catch (e) { return null; }
  }

  function esc(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function money(n) {
    var num = parseFloat(n) || 0;
    return '£' + num.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function buildHtml(hits, q) {
    if (!hits.length) {
      return '<div class=”predictive-search-feedback” data-search-results style=”padding:24px 16px;text-align:center;”>'
        + '<p style=”font-size:0.875rem;opacity:0.7;”>No results for “' + esc(q) + '”</p>'
        + '</div>';
    }

    var cards = hits.map(function (h) {
      var hasDiscount = h.compare_at_price > h.price && h.compare_at_price > 0;
      var pct = hasDiscount ? Math.round((h.compare_at_price - h.price) / h.compare_at_price * 100) : 0;
      var priceHtml = hasDiscount
        ? '<s style=”opacity:0.5;margin-right:4px;font-size:0.75rem;”>' + money(h.compare_at_price) + '</s>'
          + '<span>' + money(h.price) + '</span>'
          + '<span style=”margin-left:4px;font-size:0.72rem;opacity:0.7;”>(-' + pct + '%)</span>'
        : '<span>' + money(h.price) + '</span>';

      var imgUrl = h.image ? esc(h.image) + '?width=400' : '';
      var imgHtml = imgUrl
        ? '<img src=”' + imgUrl + '” alt=”' + esc(h.title) + '” loading=”lazy”'
          + ' style=”width:100%;height:100%;object-fit:cover;display:block;”>'
        : '';

      return '<li class=”predictive-search-results__card” role=”option” tabindex=”-1”'
        + ' style=”list-style:none;”>'
        + '<a class=”resource-card__link” href=”' + esc(h.url || '/products/' + h.id) + '”'
        + ' style=”display:block;text-decoration:none;color:inherit;”>'
          + '<div style=”aspect-ratio:4/5;overflow:hidden;background:var(--color-background-secondary,#f2f2f2);”>'
            + imgHtml
          + '</div>'
          + '<div style=”padding-top:8px;”>'
            + (h.vendor ? '<p style=”font-size:0.7rem;opacity:0.55;margin:0 0 2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;”>' + esc(h.vendor) + '</p>' : '')
            + '<p style=”font-size:0.78rem;margin:0 0 4px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;”>' + esc(h.title) + '</p>'
            + '<p style=”font-size:0.8rem;margin:0;”>' + priceHtml + '</p>'
          + '</div>'
        + '</a>'
        + '</li>';
    }).join('');

    return '<div class=”predictive-search-results__inner” data-search-results>'
      + '<ul class=”predictive-search-results__list” role=”listbox”'
      + ' style=”list-style:none;padding:12px 16px;margin:0;'
      + 'display:grid;grid-template-columns:repeat(3,1fr);gap:12px;”>'
      + cards
      + '</ul>'
      + '<div style=”padding:10px 16px;border-top:1px solid var(--color-border,rgba(0,0,0,0.1));font-size:0.82rem;”>'
        + '<a href=”/search?q=' + encodeURIComponent(q) + '&type=product”'
        + ' data-predictive-query-term=”' + esc(q) + '”'
        + ' style=”text-decoration:underline;color:inherit;”>'
          + 'View all results for “' + esc(q) + '”'
        + '</a>'
      + '</div>'
      + '</div>';
  }

  var lastQuery = '';
  var pendingTimer = null;

  function doSearch(q, container, apiUrl) {
    if (q === lastQuery) return;
    lastQuery = q;

    clearTimeout(pendingTimer);
    container.innerHTML = '<div style="padding:24px 16px;text-align:center;font-size:0.82rem;opacity:0.5;">Searching…</div>';

    pendingTimer = setTimeout(function () {
      var url = apiUrl + '/search?q=' + encodeURIComponent(q) + '&per_page=6&facet_by=vendor';
      fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || q !== lastQuery) return;
          container.innerHTML = buildHtml(data.hits || [], q);
          container.dataset.state = 'results';
        })
        .catch(function () {});
    }, 200);
  }

  function patchComponent(component) {
    if (component._tsPatched) return;

    var apiUrl = getApiUrl();
    if (!apiUrl) return;

    component._tsPatched = true;

    var originalSearch = component.search;

    component.search = function (event) {
      if (!event || !event.inputType) return;

      var refs = component.refs || {};
      var input = refs.searchInput || component.querySelector('input[name="q"]');
      var container = refs.predictiveSearchResults || component.querySelector('[ref="predictiveSearchResults"]');

      if (!input || !container) {
        if (typeof originalSearch === 'function') originalSearch.call(component, event);
        return;
      }

      var q = input.value.trim();
      if (!q) {
        lastQuery = '';
        clearTimeout(pendingTimer);
        container.dataset.state = '';
        input.setAttribute('aria-expanded', 'false');
        return;
      }

      input.setAttribute('aria-expanded', 'true');
      doSearch(q, container, apiUrl);
    };
  }

  function init() {
    document.querySelectorAll('predictive-search-component').forEach(patchComponent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-patch when dialogs open (search modal may be lazy-mounted)
  document.addEventListener('dialog:open', function () {
    setTimeout(function () {
      document.querySelectorAll('predictive-search-component').forEach(patchComponent);
    }, 50);
  });

  // Also catch components added dynamically via MutationObserver
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.tagName === 'PREDICTIVE-SEARCH-COMPONENT') patchComponent(node);
          node.querySelectorAll('predictive-search-component').forEach(patchComponent);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
